module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom14.f42279e4.jpg";